module.exports = __webpack_public_path__ + "img/T2.ec233994.png";